import { Check } from '@phosphor-icons/react';
import { Spinner } from '@skupreme/shared/ui';

type PercentageProgressProps = {
  progress: number | string | null;
};

function PercentageProgress({ progress }: PercentageProgressProps) {
  const checkWith = Number.isNaN(progress) ? null : Number(progress);
  if (checkWith !== null) {
    if (checkWith >= 100) {
      return (
        <div className="sk:inline-flex sk:items-center sk:justify-center sk:gap-1 sk:whitespace-nowrap sk:text-dense sk:text-success">
          <Check size={16} weight="bold" aria-hidden />
          <span>Connected</span>
        </div>
      );
    }
    return (
      <div className="sk:inline-flex sk:items-center sk:justify-center sk:gap-1.5 sk:whitespace-nowrap sk:text-dense sk:text-warning">
        <Spinner size="sm" label="Syncing catalog" />
        <span>{checkWith}%</span>
      </div>
    );
  }
  return null;
}

export default PercentageProgress;
